import React from 'react'
import { Spinner } from 'react-bootstrap'

const SpinnerWrapper = ({ label }) => {

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <Spinner
                animation="border"
                variant="primary"
            />
            <div>{label}</div>
        </div>
    )
}

export default SpinnerWrapper
